import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { COLUMNS } from './columns'
import Select from 'react-select'
import Table from "../../common/Table/Table";
import AddUserButton from "../../common/AddUserButton/AddUserButton";
import Modal from "../../common/Modal/Modal";
import GroceriesForm from "../../forms/GroceriesForm/GroceriesForm";
import { PencilIcon, TrashIcon } from '@heroicons/react/outline';
import ClientService from "../../../services/ClientService";
import MeasurementForm from "../../forms/MeasurementForm/MeasurementForm";
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

const MySwal = withReactContent(Swal)

const Measurements = () => {
    let { clientId } = useParams();
    const [shouldLoad, setShouldLoad] = useState(true)
    const [selectedId, setSelectedId] = useState(clientId)
    const [mappedTable, setMappedTable] = useState(null)
    const [isOpen, setIsOpen] = useState(false)
    const [measurementData, setMeasurementData] = useState({})
    const [clientsData, setClientsData] = useState([])
    const [selectedClient, setSelectedClient] = useState(null)
    const [modalTitle, setModalTitle] = useState('')
    const [buttonText, setButtonText] = useState('Dodaj Mere')
    const [measurementsData, setMeasurementsData] = useState([])

    useEffect(() => {
        if (shouldLoad) {
            setShouldLoad(false)
            getClients()
        }
    }, [shouldLoad])



    const selectClient = (client) => {
        setSelectedClient({ ...client })
        setSelectedId(client.id)
        getMeasurements(client.id)
    }

    const getClients = () => {
        ClientService.getClientsShort().then((response) => {
            let data = response.data.map(client => {
                let temp = { ...client }
                temp.value = client.name
                temp.label = client.name
                return temp
            })

            if (clientId !== ":clientId") {
                let client = data.filter(c => c.id === clientId)
                selectClient(client[0])
            }
            setClientsData(data)
        })
    };

    const getMeasurements = (id) => {
        ClientService.getMeasurements(id).then((response) => {
            setMeasurementsData([...response.data])
        });
    };

    const deleteMeasurement = (selected, id) => {
        setIsOpen(false)
        MySwal.fire({
            showCancelButton: true,
            showDenyButton: true,
            showConfirmButton: false,
            denyButtonText: `Obriši`,
            cancelButtonText: `Otkaži`,
        }).then((result) => {
            if (result.isDenied) {
                ClientService.deleteMeasurement(selected, id).then(response => {
                    setMeasurementsData([...response.data])
                });
            }
        })

    };

    const addMeasurement = (measurementsData, formValues, clientId) => {
        let tempForm = { ...formValues, id: measurementsData.id }
        console.log(tempForm);
        if (tempForm.id) {
            ClientService.updateMeasurement(clientId, tempForm).then((response) => {
                setShouldLoad(true);
                 setMeasurementsData([...response.data]) 
            });
        } else {
            ClientService.addMeasurement(clientId, tempForm).then((response) => {
                setShouldLoad(true)
                setMeasurementsData([...response.data])
            });
        }

    }


    const openModal = (row) => {
        setMeasurementData(row.original);
        setIsOpen(true);
        setModalTitle('Izmeni mere');
    };

    const additionalColumn = {
        Header: ' ',
        Cell: ({ row }) => (
            <div className="flex items-center justify-end">
                <span className="p-2 rounded-full transition cursor-pointer purpleGradient" title="Delete" onClick={() => deleteMeasurement(selectedId, row.original)}><TrashIcon className="w-4 h-4 text-white transition" /></span>
            </div>
        )
    }
    return (
        <>
            <div className={"text-xs mb-6 font-bold uppercase rounded block leading-normal flex"}>
                <AddUserButton className="" setIsOpen={setIsOpen} setUserData={setMeasurementData} setModalTitle={setModalTitle} buttonText={buttonText} />
                <Select
                    className='w-60 ml-4'
                    placeholder={'Type to search'}
                    onChange={(item) => selectClient(item)}
                    options={clientsData}
                    classNamePrefix='select'
                    value={selectedClient ? selectedClient : 'Type to search'}
                />
            </div>

            {isOpen &&
                <Modal setIsOpen={setIsOpen} modalContent={<MeasurementForm measurementData={measurementData} modalTitle={modalTitle} clientId={selectedId} setMeasurementsData={setMeasurementsData} setIsOpen={setIsOpen} deleteMeasurement={deleteMeasurement} addMeasurement={addMeasurement} />}  />
            }
            {measurementsData !== null ?
                <Table openModal={openModal} columnsProp={COLUMNS} dataProp={[...measurementsData]} setIsOpen={setIsOpen} setMeasurementData={setMeasurementsData} setModalTitle={setModalTitle} />
                : null}
        </>
    )

};

export default Measurements;
